export const getThemeProvider = ({
  organization,
  customTheme,
}: {
  organization?: string;
  customTheme?: string;
}) => {
  const fallbackTheme = 'stone'

  if (customTheme && !customTheme?.includes('#')) {
    return customTheme;
  }

  if (organization && organization !== 'pagarme') {
    return organization;
  }

  return fallbackTheme;
};
